import React from "react";
import GenericPullConfigListing from "../GenericPullConfigListing";
import PolarisCredentialsForm from "./PolarisCredentialsForm";
import PolarisMappingForm from "./PolarisMappingForm";

export default function PolarisConfigListing(props) {
  const columns = [
    {
      title: "Project",
      dataIndex: "projectName",
      width: 240,
    },
    {
      title: "Branch",
      dataIndex: "branchName",
      width: 150,
    },
  ];
  return (
    <GenericPullConfigListing
      {...props}
      toolName={props.name}
      MappingForm={PolarisMappingForm}
      CredentialsForm={PolarisCredentialsForm}
      extraColumns={columns}
      displayComponentName={"Project"}
    />
  );
}
